// extracted by mini-css-extract-plugin
var _1 = "RequestIntegration-module__form--XJgwA";
var _2 = "RequestIntegration-module__submit--WATJ5";
export { _1 as "form", _2 as "submit" }
